import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'lodash';

import { fetchTypeAheadQuery } from 'services/fetchTypeAheadQuery';
import { useAppConfig } from 'state/appConfig';
import { useChatbotQueryContext } from 'state/chatbotQueryResponseState';

const TYPE_AHEAD_QUERY_KEY = 'typeAheadQuery';

/**
 * useTypeAheadQuery
 * @description return expose a "fetchTypeAheadQuery" callback, so it can manullay trigger entry fetching,
 * instead of using "refetch" from "useQuery", which can't accept parameters.
 *
 * @param {Object} queryConfig
 * @returns {Object}
 */

export const useTypeAheadQuery = () => {
  const [query, setQuery] = useState({});
  const { queryContext } = useChatbotQueryContext();

  const { chatbotUrl } = useAppConfig();

  const typeAheadQuery = useQuery({
    queryKey: [TYPE_AHEAD_QUERY_KEY, query],
    queryFn: () =>
      fetchTypeAheadQuery(chatbotUrl, {
        entry: query,
        ...queryContext,
      }),
    enabled: !isEmpty(query),
    staleTime: Infinity,
  });

  const { data, ...rest } = typeAheadQuery;

  return {
    ...rest,
    typeAheadSuggestionList: data ?? [],
    hasSuggestionsItems: data?.length > 0,
    sendTypeAheadBotQuery: setQuery,
  };
};
